import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { COOKIES_POLICY_PAGE_PATH } from "utils/constants/paths";

const CookiesPolicyPage = Loadable(React.lazy(() => import("./View")));

export const CookiesPolicyPageRoute: IRouteItem = {
  path: COOKIES_POLICY_PAGE_PATH,
  element: React.createElement(CookiesPolicyPage),
  name: "Cookies Policy",
};
